export default ({
	className,
	'aria-hidden': ariaHidden,
	color,
}: {
	className?: string;
	'aria-hidden'?: boolean;
	color?: string;
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 512 512"
		width="6px"
		height="10px"
		version="1.1"
		className={className}
		aria-hidden={ariaHidden}
		fill={color ? color : 'currentColor'}
	>
		<path d="M267.3 395.3c-6.2 6.2-16.4 6.2-22.6 0l-192-192c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 361.4 436.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-192 192z" />
	</svg>
);
